import { Box, Button, Grid, Stack, TableCell, TableRow, Typography } from "@mui/material";
import { useAppDispatch } from "../../assets/hooks";
import { months } from "../../assets/menu";
import { DestinationTypeEnum } from "../../assets/enums";
import CustomCard from "../../components/customCard";
import { setPopup } from "../../store/slices/popupSlice";
import ReusableTable from "../../components/reusableTable";

const Courses = (props: any) => {
  const coursesRows = [
    { key: "Program", name: "Program", width: 280 },
    { key: "University", name: "University", width: 180 },
    { key: "country", name: "Country", width: 50 },
    { key: "Study Level", name: "Study Level", width: 100 },
    { key: "Duration", name: "Duration", width: 100 },
    { key: "Fee", name: "Tuition Fee(approx)", width: 140 },
    { key: "Course Starts", name: "Course Starts", width: 120 },
  ];

  const CourseData = () => {
    const dispatch = useAppDispatch();
 
    const fullToShort: Record<string, string> = Object.fromEntries(
      Object.entries(DestinationTypeEnum).map(([key, value]) => [value, key])
  );

    return (
      <>
        {props.loading ? (
          <TableRow>
            <TableCell colSpan={coursesRows.length}>
              <Typography textAlign="center">Loading ...</Typography>
            </TableCell>
          </TableRow>
        ) : props?.list?.length > 0 ? (
          props?.list?.map((course: any, i: number) => (
            <>
            <TableRow
              key={course._id}
              sx={{
                  "& .MuiTableCell-root": {
                    // padding: "10px",
                     padding: "8px",
                  border: "none",
                    // width: `${100 / (columns?.length)}%`,
                  },
                // "& .MuiTableCell-root": {
                //   padding: "8px",
                //   border: "none",
                // },
                verticalAlign: "top",
                "&:hover": {
                  // background:"red",
                  // transform:"scale(1.2)"
                },
              }}
            >
              {/* <TableCell sx={{ textAlign: "center" }}>{i + 1}</TableCell> */}
              <TableCell
                sx={{
                  cursor: "pointer",
                  "&:hover": { color: "#3B3F76", fontWeight: "500" },
                }}
                onClick={() => {
                  dispatch(
                    setPopup({
                      show: true,
                      data: {
                        container: {
                          name: "mainPopup",
                          data: course,
                          dimensions: {
                            width: "100%",
                            // height:"80%"
                          },
                        },
                        type: "custom",
                      },
                    })
                  );
                }}
              >
                <div
                  style={{ display: "flex", gap: "5px", paddingLeft: "1rem" }}
                >
                  <Box sx={{display:"flex",flexDirection:"column"}}>
                  
                  <img
                    src={course?.university?.logoSrc}
                    alt="logo"
                    style={{
                      height: "1.5rem",
                      width: "1.5rem",
                      borderRadius: "50%",
                    }}
                  />
                  </Box>
                  <div style={{ display: "flex", flexDirection: "column" }}>
                    {course?.name}
                    <Stack direction="row" spacing={1}>
                    {course?.stemDetails?.stem ? (
                      <Button
                        sx={{
                          color: "#FF751A",
                          background: "#FFDAA1",
                          borderRadius: "1rem",
                          fontSize: "10px",
                          p: 0,
                          minWidth: "3rem",
                          width:"2.9rem",
                          "&:hover": {
                            color: "#FF751A",
                            background: "#FFDAA1",
                          },
                        }}
                      >
                        STEM
                      </Button>
                    ) : (
                      ""
                    )}
                      {course?.elite ? 
             <Button
             sx={{
               color: "#008EDC",
               background: "#9ADBFF",
               borderRadius: "1rem",
               fontSize: "10px",
               p: 0,
               // minWidth: "3rem",
               textTransform:"none",
               width:"3rem",
               "&:hover": {
                 color: "#008EDC",
                 background: "#9ADBFF",
               },
             }}
           >
             Elite
           </Button>
                  :
                 ""}
                      </Stack>
                  </div>
                </div>
              </TableCell>
              <TableCell
                sx={{
                  cursor: "pointer",
                  "&:hover": { color: "cornflowerblue" },
                  color: "#6E6E6E",
                  // textAlign: "center",
                }}
                onClick={() => {
                  dispatch(
                    setPopup({
                      show: true,
                      data: {
                        container: {
                          name: "universityPopup",
                          data: course.university._id,
                          dimensions: {
                            width: "90%",
                            // height: "80%",
                          },
                        },
                        type: "custom",
                      },
                    })
                  );
                }}
              >
                {course?.university?.name }
                <br/>
                {/* {course?.university?.location?.country} */}
       
              </TableCell>
              <TableCell sx={{ color: "#6E6E6E", textAlign: "center" }}>
              {fullToShort[course?.university?.location?.country] || "Unknown"}
              </TableCell>

              <TableCell
                sx={{
                  textAlign: "center",
                }}
              >
                {course?.studyLevel}
              </TableCell>
              <TableCell sx={{ color: "#6E6E6E", textAlign: "center" }}>
                {course?.duration !== null ? (course?.duration.reduce((acc:string,curr:any,i:number)=>(acc+(`${curr?.durationType}:${curr?.duration}`)+(i<course?.duration?.length-1?",":"")),"")) : "N/A"}
                {course?.duration !== null ?
                <sup
                  style={{
                    fontSize: "9px",
                    marginLeft: "3px",
                    marginTop: "-3px",
                  }}
                >
                  months
                </sup> :""}
              </TableCell>
              <TableCell sx={{ color: "#6E6E6E" }}>
                <Typography
                  fontSize="0.85rem"
                  sx={{ display: "flex", justifyContent: "center",alignItems:"center" }}
                >
                  <Typography
                    sx={{
                      fontSize: "14px",
                      margin: "2px 2px 0 0",
                      position: "relative",
                      "&:hover .cancel-icon": {
                        display: "block !important",
                      },
                    }}
                  >
                    {" "}
                    {course?.tuitionFee?.tuitionFee
                      ? course?.currency.symbol
                      : ""}
                    <span
                      className="cancel-icon"
                      style={{
                        display: "none",
                        color: "#000",
                        position: "absolute",
                        border: "1px solid #3B3F76",
                        width: "100px",
                        zIndex: 1,
                        background: "#fff",
                        textAlign: "center",
                        fontSize: "11px",
                      }}
                    >
                      Currency :{course?.currency.code}
                    </span>
                  </Typography>
                  {course?.tuitionFee?.tuitionFee || course?.tuitionFee?.tuitionFee > 0
                    ? (
                        Math.round(course?.tuitionFee?.tuitionFee * 100) / 100
                      ).toLocaleString("en-US")
                    : "N/A"}
                  <Typography
                    component="sub"
                    sx={{
                      fontSize: "9px",
                      marginLeft: "3px",
                      marginTop: "-3px",
                    }}
                  >
                    {course?.tuitionFee?.tuitionFee
                      ? course?.tuitionFee?.tuitionFeeType
                      : ""}
                  </Typography>
                </Typography>
              </TableCell>
              <TableCell
                sx={{
                  textAlign: "center",
                }}
              >
                {course?.startDate
                  ?.map((item: any) => months[item.courseStartingMonth])
                  .join(", ")}
              </TableCell>
              <TableCell sx={{ paddingTop: "0 !important" }}>
                <div style={{ display: "flex",  }}>
                  {/* <Button
                    sx={{
                      // border: "2px solid #3B3F76",
                      color: "#3B3F76",
                      fontWeight: "600",
                      fontSize: "13px",
                      textTransform: "none",
                      borderRadius: "10px",
                      padding: "5px",
                      "&:hover": {
                        color: "#3B3F76",
                      },
                    }}
                    onClick={() =>
                      eventHandler({ name: "apply", data: course })
                    }
                  >
                    Apply now
                  </Button> */}

                </div>
              </TableCell>
            </TableRow>
            </>
          ))
        ) : (
          <TableRow>
            <TableCell colSpan={coursesRows.length}>
              <Typography textAlign="center">No data available</Typography>
            </TableCell>
          </TableRow>
        )}
      </>
    );
  };
  const Card = (data: any) => {
    const item = data.data;
    const dispatch = useAppDispatch();

    return (
      <div>
        <CustomCard title="" i={0}>
          <Box
          // sx={{display:"flex",gap:"1rem"}}
            onClick={() => {
              dispatch(
                setPopup({
                  show: true,
                  data: {
                    container: {
                      name: "mainPopup",
                      data: item,
                      dimensions: {
                        width: "80%",
                        // height:"80%"
                      },
                    },
                    type: "custom",
                  },
                })
              );
            }}
          >
              <Box sx={{display:"flex",justifyContent:"space-between",mb:1}}>
                 <Box>
                <Typography
                  fontSize="0.9rem"
                  sx={{
                    // height: "2rem",
                    fontSize: { xs: "13px", lg: "15px" },
                  }}
                >
                  {item?.name}
                </Typography>
              {/* </Tooltip> */}
              {item?.stemDetails?.stem ? (
                <Button
                  sx={{
                    color: "#FF751A",
                    background: "#FFDAA1",
                    borderRadius: "1rem",
                    fontSize: "10px",
                    p: 0,
                    minWidth: "3rem",
                    width: "2.9rem",
                    // left: "3rem",
                    "&:hover": {
                      color: "#FF751A",
                      background: "#FFDAA1",
                    },
                  }}
                >
                  STEM
                </Button>
              ) : (
                ""
              )}
              </Box>
                 </Box>
            <Box sx={{display:"flex",gap:"10px",width:"100%"}}>
              <img
                src={item?.university?.logoSrc}
                alt="logo"
                style={{
                  width: "2rem",
                  height: "2rem",
                  marginRight: "5px",
                  borderRadius: "50%",
                }}
              />
               <div style={{}}>
               
              
              <Stack sx={{ my: 1 }} spacing={1}>
              <Typography fontSize="0.8rem" color="#8D8B8B">
                {item?.university?.name}
              </Typography>
              <Typography fontSize="0.8rem" >
                {item?.university?.location?.country}
              </Typography>
              <Stack
                direction="row"
                alignItems="center"
                spacing={1}
                sx={{
                  flexWrap: "nowrap",
                  height: "1.5rem",
                  fontWeight: 600,
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                  overflow: "hidden", 
                }}
              >

                <Typography fontSize="0.8rem">
                  {item?.studyLevel} |
                </Typography>
                <Typography fontSize="0.8rem">
                  {item?.duration ? (item?.duration.reduce((acc:string,curr:any,i:number)=>(acc+(`${curr?.durationType}:${curr?.duration}`)+(i<item?.duration?.length-1?",":"")),"")
                ) : ""}{" "}
                  <sup
                    style={{
                      fontSize: "9px",
                      marginTop: "-3px",
                    }}
                  >
                    months
                  </sup>{" "}
                  |
                </Typography>
                <Typography fontSize="0.8rem" sx={{ display: "flex",alignItems:"center" }}>
                  <Typography
                    sx={{
                      fontSize: "13px",
                      // margin: "2px 2px 0 0",
                      position: "relative",
                      "&:hover .cancel-icon": {
                        display: "block !important",
                      },
                      display: "flex",alignItems:"center"
                    }}
                  >
                    {" "}
                    {item?.tuitionFee?.tuitionFee
                      ? item?.currency?.symbol
                      : ""}
                    <span
                      className="cancel-icon"
                      style={{
                        display: "none",
                        color: "#000",
                        position: "absolute",
                        border: "1px solid #7d7d7d",
                        width: "100px",
                        zIndex: 1,
                        background: "#fff",
                        textAlign: "center",
                        top: "0px",
                      }}
                    >
                      Currency :{item?.currency?.code}
                    </span>
                  </Typography>
                  {item.tuitionFee?.tuitionFee
                    ? (
                        Math.round(item?.tuitionFee?.tuitionFee * 100) /
                        100
                      ).toLocaleString("en-US")
                    : "N/A"}
                  <sup
                    style={{
                      fontSize: "9px",
                      marginLeft: "3px",
                      marginTop: "-3px",
                    }}
                  >
                    {item.tuitionFee?.tuitionFeeType}
                  </sup>
                </Typography>
              </Stack>
            </Stack>
              </div>
            </Box>

          </Box>
         
        </CustomCard>
      </div>
    );
  };

  const CourseCards = () =>{
    return(
      <div>

            <Box sx={{}}>
          <Grid
            container
            spacing={2}
            sx={{
              minHeight:"600px",maxHeight:"650px",
              height:"100%",
              overflowY: "scroll",
            }}
          >
          {props?.list?.length > 0 ? (
          props?.list?.map((course: any, i: number) => (
            <Grid item xs={12} sm={6}>
            <Card data={course} key={course._id} />
            </Grid>
           ))
           ) :""}
         
          </Grid>
        </Box>
      </div>
    )
  }
  return (
    <Box sx={{ px: "1rem" }}>
      
        <Box sx={{display:{xs:"none",lg:"block"}}}>
        <ReusableTable columns={coursesRows} data={<CourseData />} />
           </Box>
           
           <Box sx={{display:{xs:"block",lg:"none"}}}>
             <CourseCards/>
           </Box>
    </Box>
  );
};

export default Courses;
